import React from 'react'

import { getPhoneParts } from '../talent.utils'
import styles from './TalentPhoneValue.module.css'

const TalentPhoneValue = ({ record, className = '', muted = false }) => {
    const parts = getPhoneParts(record)

    if (!parts) {
        return (
            <span className={`${className} ${muted ? styles.muted : ''}`}>—</span>
        )
    }

    return (
        <span className={className}>
            {parts.countryCode ? (
                <span className={styles.phoneCode}>{parts.countryCode} </span>
            ) : null}
            <span className={styles.phoneNumber}>{parts.number}</span>
        </span>
    )
}

export default TalentPhoneValue
